import _ from '@lodash';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import MobileDetect from 'mobile-detect';
import React from 'react';

const md = new MobileDetect(window.navigator.userAgent);

class ToggleFiltro extends XAPPComponent {

    state = {
        openFiltro: md.mobile() === null && md.tablet() === null ? true : false
    }

    toggleSidebar = () => {
        if (md.mobile() === null && md.tablet() === null && window.innerWidth > 1281) {
            if (document.getElementById("rightSidebarContent").parentNode.parentNode.parentNode.style.display === 'none') {
                document.getElementById("rightSidebarContent").parentNode.parentNode.parentNode.style.display = '';
                this.setState(_.set({ ...this.state }, "openFiltro", true));
            }
            else {
                document.getElementById("rightSidebarContent").parentNode.parentNode.parentNode.style.display = 'none';
                this.setState(_.set({ ...this.state }, "openFiltro", false));
            }
        }
        else {
            this.props.toggleRightSidebar();
            this.setState(_.set({ ...this.state }, "openFiltro", this.state.openFiltro));
        }
    }

    render() {
        const { parametros, xappRouteParams, getFiltro, onChangeRange, setIntervalo, intervaloAgendamento } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                <XAPPButton
                    tooltip={{ "title": (form.openFiltro ? "Ocultar filtro" : "Filtro"), "placement": "top" }}
                    type="Icon"
                    onClick={this.toggleSidebar}
                    aria-label="open right sidebar"
                    className="text-white"
                    icon={form.openFiltro ? "remove_filtro" : "filtro"}
                />
            </React.Fragment>
        );
    };
}

export default ToggleFiltro;